export default __webpack_public_path__ + "static/media/fastingtime@3x.5a681c24.jpg";